import Inputmask from 'inputmask';

// custom placeholders
export function initPlaceholders() {
    $('.placeholder').each(function () {
        if ($(this).hasClass('ready')) return;

        const $this = $(this);

        const $field = $this.parents('.field');
        const plh = $this.data('placeholder');
        const val = $.trim($this.val());
        if ((val == '' || val == plh) && plh != '' && plh != undefined) {
            $field.addClass('empty');

        } else {
            $field.removeClass('empty');
        }

        $field.prepend('<span class="label">' + plh + '</span>');

        $(this).addClass('ready');

        $(this)
            .on('focus', function () {

                var $this = $(this),
                    $field = $this.parents('.field'),
                    plh = $this.attr('data-placeholder'),
                    val = $.trim($this.val());

                if ($this.prop('readonly')) return false;

                if (val == '' || val == plh) {
                    $field.removeClass('empty');
                }
            })
            .on('blur', function () {
                var $this = $(this),
                    $field = $this.parents('.field'),
                    plh = $this.attr('data-placeholder'),
                    val = $.trim($this.val());

                if (val == '' || val == plh) {
                    $field.removeClass('error success').addClass('empty');

                } else {
                    $field.removeClass('empty');
                }
            });
    });
}

/**
 * Инициализация инпатов с вводом денежного формата
 */
export function initMoneyInput() {
    $('.input-money').each(function () {
        const $field = $(this);
        if ($field.hasClass('mask-ready')) return;

        const currency = $field.attr('data-currency') || ' ₽';

        Inputmask({
            alias: 'numeric',
            numericInput: true,
            digits: 0,
            digitsOptional: false,
            radixPoint: '.',
            placeholder: '',
            groupSeparator: ' ',
            autoGroup: true,
            min: 0,
            max: 999999999,
            suffix: currency,
            allowMinus: false,
            rightAlign: false,
            showMaskOnHover: false,
            autoUnmask: true,
            // showMaskOnFocus: false,
            // clearMaskOnLostFocus: true
        }).mask($field[0]);

        $field.addClass('mask-ready');
    });
}
